/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendOpportunityRequest
 */
export interface SendOpportunityRequest {
    /**
     * 
     * @type {string}
     * @memberof SendOpportunityRequest
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof SendOpportunityRequest
     */
    fields: string;
}

/**
 * Check if a given object implements the SendOpportunityRequest interface.
 */
export function instanceOfSendOpportunityRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guid" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function SendOpportunityRequestFromJSON(json: any): SendOpportunityRequest {
    return SendOpportunityRequestFromJSONTyped(json, false);
}

export function SendOpportunityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendOpportunityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guid': json['guid'],
        'fields': json['fields'],
    };
}

export function SendOpportunityRequestToJSON(value?: SendOpportunityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guid': value.guid,
        'fields': value.fields,
    };
}

